import { style } from '@vanilla-extract/css';

export const postCommentsElement = style({
  fontFamily: 'var(--comments-form-font-family)',
  fontWeight: 'var(--comments-form-font-weight)',
});

export const dropdownText = style({
  color: 'var(--comments-form-dropdown-text-color)',
});

export const dropdownBackground = style({
  background: 'var(--comments-form-dropdown-background-color)',
});

export const dropdownBorder = style({
  borderStyle: 'var(--comments-form-dropdown-border-style)',
  borderWidth: 'var(--comments-form-dropdown-border-width)',
  borderColor: 'var(--comments-form-dropdown-border-color)',
  borderRadius: 'var(--comments-form-dropdown-border-radius)',
});
